/**
 * Redirect URL utilities for secure authentication flows.
 * Validates redirect URLs to prevent open redirect vulnerabilities.
 */

// Paths that should never be used as redirect targets
const BLOCKED_PATHS = ['/kijelentkezes', '/api/', '/admin']

/**
 * Validates a redirect URL to ensure it's safe (internal path only, no open redirects).
 * Returns the validated URL or null if invalid.
 */
export function validateRedirectUrl(url: string | null | undefined): string | null {
  if (!url) return null

  // Must start with / (relative path only)
  if (!url.startsWith('/')) return null

  // Block protocol-relative URLs (//example.com)
  if (url.startsWith('//')) return null

  // Block sensitive paths
  for (const blocked of BLOCKED_PATHS) {
    if (url.startsWith(blocked)) return null
  }

  return url
}

/**
 * Builds a login URL with an optional redirect parameter.
 */
export function buildLoginUrl(redirectTo?: string): string {
  const validRedirect = validateRedirectUrl(redirectTo)
  if (validRedirect) {
    return `/belepes?redirect=${encodeURIComponent(validRedirect)}`
  }
  return '/belepes'
}

/**
 * Builds a registration URL with an optional redirect parameter.
 */
export function buildRegistrationUrl(redirectTo?: string): string {
  const validRedirect = validateRedirectUrl(redirectTo)
  if (validRedirect) {
    return `/regisztracio?redirect=${encodeURIComponent(validRedirect)}`
  }
  return '/regisztracio'
}
